module.exports = __webpack_public_path__ + "images/Luke_Miller.jpg?v=5f9e9301d8678eeeea0a2d57daefefe0";